import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'lib-svg-sprite',
  imports: [CommonModule],
  templateUrl: './svg-sprite.component.html',
  styles: [':host {display: none}'],
})
export class SvgSpriteComponent {

}
